export default {
    listagem: {
        titulo_pagina: 'Lista de Atributos',
        novo: 'Criar novo Atributo',
        table: {
            empty: 'Nenhum Atributo encontrado',
            nome: 'Nome',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Atributo',
            editar: 'Editar Atributo'
        },
        fields: {
            nome: {
                label: 'Nome',
                description: 'Nome do Atributo'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Atributo'
            },
            botao_salvar : 'Salvar Atributo'
        },
        create: {
            success: 'Atributo criado com Sucesso!',
            error: 'Error ao criar Atributo!'
        },
        update: {
            success: 'Atributo editado com Sucesso!',
            error: 'Error ao editar Atributo!'
        }
    }
}
